














import { Component, Vue } from 'vue-property-decorator';
export const planData: any[] = ['', ''];

@Component
export default class App extends Vue {}
